/**
 * 箭头
 *
 * @filename packages/react-components/src/icons/Arrow.tsx
 * @author Mr Prince
 * @date 2023-06-01 14:59:34
 */

const Arrow = () => (
  <svg
    className="icon-arrow"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2539"
    width="16"
    height="16"
  >
    <path
      d="M384 512L731.733333 202.666667c17.066667-14.933333 19.2-42.666667 4.266667-59.733334-14.933333-17.066667-42.666667-19.2-59.733333-4.266666l-384 341.333333c-10.666667 8.533333-14.933333 19.2-14.933334 32s4.266667 23.466667 14.933334 32l384 341.333333c8.533333 6.4 19.2 10.666667 27.733333 10.666667 12.8 0 23.466667-4.266667 32-14.933333 14.933333-17.066667 14.933333-44.8-4.266667-59.733334L384 512z"
      p-id="2540"
    />
  </svg>
);

export default Arrow;
